import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import DataService from "../../../../../Service";
import { CircularProgress } from "@material-ui/core";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import { showSnackbar } from "../../../../../Components/Snackbar/SnackbarActions";
import { useDispatch } from "react-redux";
import CrfDialogHeader from "../ManageCompleteCrf/CrfDialogHeader";
import CrfFormComponent from "./CrfFormComponent";

const employeeKeys = {
  home_based_location: "home_address",
  level: "level_or_grade",
  contact_details_phone_number: "mobile",
  location: "office_address",
  "office_based_location_(city/country)": "office_address",
  pa_name: "line_manager_pa_name",
  pa_email_address: "line_manager_pa_contact_details",
  "People partner email address": "people_partner_email_address",
  line_manager_email_address: "line_manager_contact_details",
  contact_details_email: "primary_email",
  contact_details_telephone_number: "telephone",
  human_capital_partner_email_address: "hr_sponsor_contact_details",
  line_manager_name: "line_manager_name",
  name_of_human_capital_partner: "hr_sponsor_name",
  lob_leader: "lob_leader_name",
};

function TabPanel(props) {
  const { children, value: tabNumber, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={tabNumber !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {tabNumber === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

let sectionId = "";
let crfFromId = "";
function a11yProps(index, item) {
  sectionId = item.id;
  crfFromId = item.coaching_request_form_id;
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

function CompleteCrf(props) {
  const classes = useStyles();

  const { handleClose, CoachinRequest, getCRFList } = props;

  const [answerData, setAnswerData] = useState({});
  const [loading, setLoading] = useState(false);
  const [crfStatus, setCrfStatus] = useState({});
  const [viewCrf, setViewCrf] = useState([]);
  const [tabNumber, setTabNumber] = React.useState(0);
  const [empId, setEmpId] = useState(undefined);

  const [employeesListForOrg, setEmployeesListForOrg] = useState([]);

  const dispatch = useDispatch();

  // Handler functions

  const handleFormInputChange = (elemId, changedValue) => {
    console.log(elemId, changedValue, "changed value");

    setViewCrf((prev) => {
      const crfFields = prev.map((crfSection) => {
        const newCrfSection = { ...crfSection };
        newCrfSection.crf_fields = newCrfSection.crf_fields.map(
          (crfFieldOld) => {
            const crfField = { ...crfFieldOld };
            if (crfField.id === elemId) {
              crfField.answer = changedValue;
            }
            return crfField;
          }
        );
        return newCrfSection;
      });
      return crfFields;
    });
    setAnswerData((prev) => {
      return { ...prev, [elemId]: changedValue };
    });
  };

  const handleTabChange = (event, newValue) => {
    setTabNumber(newValue);
  };

  useEffect(() => {
    getCrfData();
  }, [CoachinRequest]);

  const getCrfData = () => {
    setLoading(true);
    const params = {
      coaching_request_form_id: CoachinRequest.coaching_request_form_id,
      crf_user_id: CoachinRequest.id,
    };
    DataService.getDirectData(`/crf_users/view_crf`, params)
      .then((response) => {
        let listData = response.coaching_request_form.crf_form_sections;
        let empId = response.coaching_request_form.employee_id;
        setEmpId(empId);
        setCrfStatus(response.coaching_request_form);
        setViewCrf(listData);
        const orgId = response.coaching_request_form.organisation_id;
        getEmpListingForOrg(orgId);
      })
      .catch((err) => {
        dispatch(
          showSnackbar("error", ["Couldn't fetch CRF", "Please try again"])
        );
        handleClose();
      });
  };

  const getEmpListingForOrg = (organisationId) => {
    if (organisationId) {
      const params = {
        organisation_id: organisationId,
      };
      DataService.getDirectData(`/coaching_request_forms/employee_list`, params)
        .then((response) => {
          setEmployeesListForOrg(response["employees"] || []);
        })
        .catch((err) => {})
        .finally(() => {
          setLoading(false);
        });
    } else {
      dispatch(showSnackbar("error", ["Something went wrong"], 1000));
    }
  };

  const getEmployeeDetails = (employeeId) => {
    if (employeeId) {
      const params = {
        employee_id: employeeId,
      };
      DataService.getDirectData(
        `/coaching_request_forms/employee_detail`,
        params
      )
        .then((response) => {
          setEmpId(employeeId);
          let listData = response.employee_detail;
          let answerFields = {};

          const coacheeNameFieldId = viewCrf
            .map((el) => {
              return el.crf_fields;
            })
            .flatMap((el) => el)
            .find((el) => el.field_name === "coahee_name");
          if (coacheeNameFieldId) {
            answerFields[coacheeNameFieldId.id] = `${employeeId}`;
          }
          const employeeDetailKeys = Object.keys(employeeKeys);
          setViewCrf((prev) => {
            const crfFields = prev.map((crfSection) => {
              const newCrfSection = { ...crfSection };
              newCrfSection.crf_fields = newCrfSection.crf_fields.map(
                (crfFieldOld) => {
                  const crfField = { ...crfFieldOld };
                  if (employeeDetailKeys.includes(crfField.field_name)) {
                    crfField.answer =
                      listData[employeeKeys[crfField.field_name]];
                    answerFields[crfField.id] =
                      listData[employeeKeys[crfField.field_name]];
                  } else if (crfField.field_name === "coahee_name") {
                    crfField.answer = `${employeeId}`;
                  }
                  return crfField;
                }
              );
              return newCrfSection;
            });
            console.log(answerFields, crfFields, prev, "crf fields");
            return crfFields;
          });
          setLoading(false);
          setAnswerData({ ...answerData, ...answerFields });
          dispatch(
            showSnackbar("success", ["Details updated successfully"], 1000)
          );
        })

        .catch((err) => {
          dispatch(
            showSnackbar("error", [
              "Something went wrong while fetching employees data",
              "Please try again",
            ])
          );
        });
    }
  };

  const handleSubmit = () => {
    setLoading(true);
    let quesArr = [];
    for (var i in answerData) {
      if (!(i === "null" || i === null || answerData[i] === null)) {
        quesArr.push({ crf_field_id: i, value: answerData[i] });
      }
    }
    const statusData = {
      coaching_request_form_id: crfFromId,
      crf_form_section_id: sectionId,
      crf_answers: JSON.stringify(quesArr),
      crf_user_id: CoachinRequest.id,
    };

    DataService.createData(statusData, "crf_answers")
      .then((res) => {
        if (tabNumber + 1 < viewCrf.length) {
          setTabNumber((prev) => prev + 1);
        }
        getCrfData();
        dispatch(showSnackbar("success", ["Successfully saved!"]));
      })
      .catch((err) => {
        dispatch(showSnackbar("error", [["" + err.errors]]));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const headerProps = {
    crfStatus,
    handleClose,
    CoachinRequest,
    getCrfData,
    setLoading,
    empId,
    loading,
    getCRFList,
  };

  const crfFormProps = {
    employeesListForOrg,
    crfStatus,
    getEmployeeDetails,
    handleFormInputChange,
  };

  const crfSectionsToDisplay =
    viewCrf?.filter(
      (selected_field) => selected_field.section_name !== "Description"
    ) || [];
  console.log(viewCrf, "view crf", crfSectionsToDisplay);
  return (
    <div>
      <Dialog
        fullScreen
        maxWidth={"xl"}
        disableBackdropClick
        disableEscapeKeyDown
        open={true}
        onClose={handleClose}
        aria-labelledby="base-station-manage"
      >
        <CrfDialogHeader {...headerProps} />
        <DialogContent style={{ backgroundColor: "#fff", paddingTop: 0 }}>
          {loading ? (
            <div
              style={{
                width: "100%",
                height: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CircularProgress color="primary" size={50} />
            </div>
          ) : (
            <div className={classes.root}>
              <div className={classes.tabsContainer}>
                <Tabs
                  value={tabNumber}
                  onChange={handleTabChange}
                  classes={{ root: classes.tabRoot }}
                >
                  {crfSectionsToDisplay?.map((item1, index) => {
                    return (
                      <Tab
                        label={item1.section_name}
                        classes={{ root: classes.tabs }}
                        {...a11yProps(index, item1)}
                        style={{ textTransform: "initial" }}
                        disableFocusRipple
                        disableRipple
                        disableTouchRipple
                        key={item1.section_name}
                      />
                    );
                  })}
                </Tabs>
              </div>
              {crfSectionsToDisplay?.map((item, index) => {
                return (
                  <TabPanel
                    className={classes.demo2}
                    value={tabNumber}
                    index={index}
                  >
                    <Grid container>
                      {crfSectionsToDisplay[tabNumber]?.crf_fields.map(
                        (row) => (
                          <CrfFormComponent row={row} {...crfFormProps} />
                        )
                      )}
                    </Grid>
                  </TabPanel>
                );
              })}
              <Grid container direction="row" alignItems="flex-start">
                <Grid item xs={10}></Grid>
                <Grid item xs={2}>
                  <div className={classes.stepperButtons}>
                    <Button
                      disableElevation
                      disabled={loading}
                      variant="contained"
                      style={{ background: "#EF7000", color: "white" }}
                      className={classes.btnSearch}
                      onClick={handleSubmit}
                    >
                      {loading && (
                        <CircularProgress
                          className={classes.circularProgress}
                          size={20}
                        />
                      )}
                      {tabNumber + 1 === viewCrf.length ? "Submit" : "Save"}
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </div>
          )}
        </DialogContent>
      </Dialog>
      )
    </div>
  );
}

export default CompleteCrf;

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: "100%",
  },
  indicator: {
    backgroundColor: "white",
  },

  selected: {
    backgroundColor: "green !important",
  },
  stepperButtons: {
    position: "fixed",
    display: "flex",
    justifyContent: "space-between",
    bottom: "3%",
    backgroundColor: "white",
    padding: "10px 0px 20px 0px",
    zIndex: 1,
  },
  formWrapper: {
    background: "#fff",
    width: "400px",
    padding: theme.spacing(3),
  },
  title: {
    textTransform: "capitalize",
  },
  btnSearch: {
    textTransform: "capitalize",
  },
  actionButtons: {
    paddingTop: "35px",
    textAlign: "center",
    "& button": {
      marginRight: "20px",
      //   height:'16px'
    },
  },
  tabStyle: {
    borderRadius: "7px",
    marginRight: "20px",
    height: "16px",
    textTransform: "initial",
  },
  tabRoot: {
    "& .MuiTabs-flexContainer": {
      justifyContent: "flex-start",
    },
    "& .MuiTabs-indicator": {
      backgroundColor: "transparent",
    },
    actionButtons: {
      paddingTop: "35px",
      textAlign: "center",
      "& button": {
        marginRight: "20px",
        //   height:'16px'
      },
    },
    tabStyle: {
      borderRadius: "7px",
      marginRight: "20px",
      height: "16px",
      textTransform: "initial",
    },
    tabRoot: {
      "& .MuiTabs-flexContainer": {
        justifyContent: "flex-start",
      },
      "& .MuiTabs-indicator": {
        backgroundColor: "transparent",
      },
    },
  },
  tabsContainer: {
    position: "sticky",
    top: 0,
    backgroundColor: "#fff",
    zIndex: 100,
    borderBottom: "8px solid #fff",
  },
  tabs: {
    color: "rgb(30,30,30)",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#ddd",
    backgroundColor: " rgba(7,127,131,0.75)",
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    marginRight: 10,
    minWidth: 130,
    textTransform: "capitalize",
    "&:hover,&.Mui-selected": {
      color: "#fff",
      backgroundColor: "rgba(7,127,131,1)",
      opacity: 1,
    },
  },
}));
